import './Footer.scss'
import { useContext } from 'react'
import { ThemeContext } from '../../context'

export default function Footer()
{
    const {theme} = useContext(ThemeContext)

    return(
        <footer className={`footer_${theme}`}>©Durand Amaury</footer>
    )
}